import Vue from 'vue'
import { vfmPlugin } from 'vue-final-modal'

Vue.use(vfmPlugin)
const el = document.querySelector('.module--video')
if (el !== null) {
  // eslint-disable-next-line no-unused-vars
  const app = new Vue({
    el: '#video-app',
    name: 'vue-final-modal',
    data: () => ({
      showModal: false,
      videoUrl: null,
      videoTitle: null,
      youtubeOpts: {
        autoplay: 1,
        cc_load_policy: 1,
        color: null,
        controls: 1,
        disablekb: 0,
        enablejsapi: 0,
        end: null,
        fs: 1,
        h1: null,
        iv_load_policy: 1,
        list: null,
        listType: null,
        loop: 0,
        modestbranding: 1,
        origin: null,
        playlist: null,
        playsinline: null,
        rel: 0,
        showinfo: 1,
        start: 0,
        wmode: 'transparent',
        theme: 'dark'
      },
      vimeoOpts: {
        api: false,
        autopause: true,
        autoplay: true,
        byline: true,
        callback: null,
        color: null,
        height: null,
        loop: false,
        maxheight: null,
        maxwidth: null,
        player_id: null,
        portrait: true,
        title: true,
        width: null,
        xhtml: false
      }
    }),
    delimiters: ['[[', ']]'],
    methods: {
      getQueryString (obj) {
        let url = ''
        for (var key in obj) {
          // eslint-disable-next-line no-prototype-builtins
          if (obj.hasOwnProperty(key)) {
            if (obj[key] !== null) {
              url += key + '=' + obj[key] + '&'
            }
          }
        }
        return url.substr(0, url.length - 1)
      }
    },
    computed: {
      fullVideoUrl () {
        let url = ''
        const yt = this.videoUrl.match(/^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/)
        const vimeo = this.videoUrl.match(/https?:\/\/(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^/]*)\/videos\/|album\/(\d+)\/video\/|video\/|)(\d+)(?:$|\/|\?)/)
        const queryArgs = yt
          ? this.getQueryString(this.youtubeOpts)
          : vimeo
            ? this.getQueryString(this.vimeoOpts)
            : null
        if (yt) {
          url = '//www.youtube.com/embed/' + yt[7] + '?' + queryArgs
        } else if (vimeo) {
          url = '//player.vimeo.com/video/' + vimeo[3] + '?' + queryArgs
        }
        return url
      }
    },
    beforeMount () {
      const videoContainer = document.querySelector("[id^='video-trigger--']")
      this.videoUrl = videoContainer.getAttribute('data-video-url')
      this.videoTitle = videoContainer.getAttribute('data-video-title')
    },
    watch: {
      showModal: {
        handler: function (val) {
          if (this.showModal) {
            document.documentElement.classList.add('is-clipped')
          } else {
            document.documentElement.classList.remove('is-clipped')
          }
        }
      }
    }
  })
}
